import Enumerable from "linq";
import { RelationalActionKinds } from "../RelationalActionKinds";
import { IItem } from "./IItem";
import { IRelational, instanceOfIRelational } from "./IRelational";

export interface ISourceEditable extends IRelational {
  source: IItem;
}

export function instanceOfISourceEditable(instance: any): instance is ISourceEditable {
  return instance
    && (instance.source !== undefined)
    && instanceOfIRelational(instance)
    && Enumerable.from(instance.actions).any(a => a.kind === RelationalActionKinds.Alternative);
}
